import { FuelTag } from '@frete.com/fuel-react';
import React from 'react';

export const VipTag = () => (
  <FuelTag highlight data-testid="vip-tag" label="VIP" shape="rectangle" uppercase icon="diamond" iconStyle="filled" />
);
